module.exports = __webpack_public_path__ + "media/images/top/ranking-sample07-52159741a863d57229af220737f67218.jpg";